/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waterfall_Chain_Max_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "In rare cases, blocks are created unusually quickly, which can result in artificially low block times.<br /><br />This variability explains why Waterfall’s <..." |
*
* @param {Waterfall_Chain_Max_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waterfall_chain_max_tps_explanation = /** @type {((inputs?: Waterfall_Chain_Max_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waterfall_Chain_Max_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("In rare cases, blocks are created unusually quickly, which can result in artificially low block times.<br /><br />This variability explains why Waterfall’s <strong>Max TPS (1 block)</strong> can exceed its <strong>Max Theoretical TPS</strong>.")
});